


























































import Vue from "vue";
import { Component, Watch, Prop } from "vue-property-decorator";
import FormField from "@/components/AFormField.vue";

interface DropFiles {
    hstId: string | null;
    file: File;
}

@Component({
    components: {
        FormField,
    },
})
export default class ServiceCaseFileUpload extends Vue {
    dropFiles: DropFiles[] = [];
    dropFilesEditDeleted: DropFiles[] = [];
    isDropFilesModalActive = false;
    fileTypes = [
        "application/pdf",
        "text/plain",
        "text/csv",
        "application/msword",
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "application/vnd.oasis.opendocument.text",
        "application/vnd.oasis.opendocument.spreadsheet",
        "application/rtf",
        "application/vnd.ms-powerpoint",
        "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "application/vnd.ms-excel",
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "application/xml",
        "text/xml",
    ];

    @Prop(Array)
    files!: DropFiles[];

    get dropFilesModel() {
        if (this.dropFiles.length > 0) {
            const files: File[] = this.dropFiles.map(d => d.file);

            return files;
        }

        return [];
    }

    set dropFilesModel(files: File[]) {
        const newFiles = files.slice(this.dropFiles.length);
        const fileList: DropFiles[] = newFiles.map(file => {
            return {
                hstId: null,
                file,
            };
        });
        this.dropFiles.push(...fileList);

        if (
            this.dropFiles.some(
                file => file.file.size > 10000000 || !this.dropFiles.some(dropFile => this.validFileType(dropFile.file))
            )
        ) {
            this.isDropFilesModalActive = true;
        }
    }

    validFileType(file: File) {
        return this.fileTypes.includes(file.type);
    }

    dropfilesModalOk() {
        this.dropFiles = this.dropFiles.filter(dropFile => dropFile.file.size < 10000001); // remove files larger than 10MB
        this.dropFiles = this.dropFiles.filter(dropFile => this.validFileType(dropFile.file)); // remove files with invalid type
        this.isDropFilesModalActive = false;
    }

    formatBytes(bytes: number, decimals = 2) {
        if (bytes === 0) {
            return "0 Bytes";
        }

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    }

    deleteDropFile(index: number) {
        if (this.dropFiles[index].hstId) {
            this.dropFilesEditDeleted.push(this.dropFiles[index]);
        }
        this.dropFiles.splice(index, 1);
    }

    dropFileErrorLabelTwo(file: File) {
        const sizeMsg = file.size > 10000000 ? this.$t("registerCases.fileSize") : "";
        const typeMsg = !this.validFileType(file) ? this.$t("registerCases.fileType") : "";

        return sizeMsg + " " + typeMsg;
    }

    dropFileErrorLabel(file: File) {
        const sizeMsg = file.size > 10000000 ? this.$t("registerCases.fileTooLarge") : "";
        const typeMsg = !this.validFileType(file) ? this.$t("registerCases.fileNotSupported") : "";

        return sizeMsg + " " + typeMsg;
    }

    @Watch("dropFiles")
    updateFiles() {
        this.$emit("dropFiles", this.dropFiles);
    }

    @Watch("dropFilesEditDeleted")
    updateDeletedFiles() {
        this.$emit("dropFilesDeleted", this.dropFilesEditDeleted);
    }

    @Watch("files")
    updateDropFiles() {
        this.dropFiles = this.files;
    }
}
